<template>
  <div>
    <v-card class="modern-list-container pa-5 mt-5">
      <v-row align="center">
        <v-col cols="12" md="auto" class="text-start">
          <span class="textLight--text font-weight-medium text-h5">
            {{ $t("course.courses") }}
          </span>
        </v-col>

        <v-spacer />

        <v-col cols="12" md="auto">
          <create-new-course v-if="havePermissionCreateTraining" />
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            v-model="coursesType"
            hide-details
            :items="items"
            item-value="value"
            outlined
            dense
            background-color="white"
            class="rounded-lg"
          >
            <template v-slot:item="{ item }">
              {{ item.text }}
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="search"
            hide-details
            prepend-inner-icon="mdi-magnify"
            color="textLight"
            :placeholder="$t('course.search')"
            outlined
            dense
            background-color="white"
            clearable
            class="shrink rounded-lg"
          />
        </v-col>
      </v-row>

    <v-row>
      <v-col>
        <available-courses-list
          :data="coursesData"
          :loading="loading"
          @cardReRender="$emit('statisticsReRender')"
          @coursesReRender="refetch()"
        />
      </v-col>

      <v-col cols="12" v-if="coursesData && coursesData.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
    </v-card>
  </div>
</template>

<script>
import AvailableCoursesList from "./AvailableCoursesList.vue";
import CreateNewCourse from "@/app/course-module/components/CourseCreateBtn";
import Pagination from "../../core-module/components/Pagination.vue";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    CreateNewCourse,
    AvailableCoursesList,
    Pagination,
  },
  data() {
    return {
      search: null,
      coursesData: [],
      totalCount: null,
      coursesType: "APPROVED",
      items: [
        {
          text: "Available",
          value: "APPROVED",
        },
        {
          text: "Approval Pending",
          value: "PENDING",
        },
        {
          text: "Enabled",
          value: "ENABLED",
        },
        {
          text: "Disabled",
          value: "DISABLED",
        },
        {
          text: "Rejected",
          value: "REJECTED",
        },
        {
          text: "Preparing",
          value: "PREPARING",
        },
      ],
      loading: true,
      variables: {
        limit: 10,
        skip: 0,
      },
      debounceSearch: null,
      totalPages: 0,
    };
  },
  created() {
    this.$apollo.queries.getTrainings.refetch();
  },
  apollo: {
    getTrainings() {
      return {
        query: require("../../course-module/api/query/getTrainings.gql"),
        variables: {
          limit: this.variables.limit,
          skip: this.variables.skip,
          filterInput: {
            approvalStatus: "APPROVED",
          },
        },
        result({ data, loading }) {
          if (data && data.getTrainings && data.getTrainings.trainings) {
            this.coursesData = data.getTrainings.trainings;
            this.totalCount = data.getTrainings.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }
          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);
      this.debounceSearch = setTimeout(() => {
        this.apiSearch();
      }, 500);
    },
    coursesType() {
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 0) {
        this.variables = this.variablesDefaultValue();
        this.search = searchText;
        this.refetch();
      } else if (searchText.length === 0) {
        this.search = null;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    havePermissionCreateTraining() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    // async fetchAll() {
    //   this.variables.limit = 0;
    //   this.variables.skip = 0;
    //   this.refetch();
    // },
    fetchIsActive() {
      if (this.coursesType === "ENABLED") {
        return true;
      } else if (this.coursesType === "DISABLED") {
        return false;
      } else null;
    },
    fetchApprovalStatus() {
      if (
        this.coursesType === "APPROVED" ||
        this.coursesType === "PENDING" ||
        this.coursesType === "REJECTED" ||
        this.coursesType === "PREPARING"
      ) {
        return this.coursesType;
      } else return null;
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    async refetch() {
      this.loading = true;
      this.$apollo.queries.getTrainings.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: {
          search: this.search ? this.search : null,
          approvalStatus: this.fetchApprovalStatus(),
          isActive: this.fetchIsActive(),
        },
      });
    },
    setCourseTypeFilter(value) {
      this.search = null;
      this.coursesType = value;
    },
  },
};
</script>

<style scoped>
.modern-list-container {
  border-radius: 16px !important;
  background: #f8f9fa !important;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 30px 0 rgba(31, 38, 135, 0.05) !important;
}
</style>
